import * as React from "react";
import { useTranslation } from "react-i18next";
import HeroImage from "./hero";
import { Announcement, Faqs, AboutAuthors, Acknowledgement, TrustedBy, Testimonials, Changelog } from "../../common";
import { SectionNav, type NavSection } from "@multiagentbook/ui";
import {
  expertTestimonials,
  readerTestimonials,
} from "@multiagentbook/shared";
import { PicoAgentsPlayground } from "../../picoagents";
import ReadingJourney from "../../reading-journey/ReadingJourney";

const printSellers = [
  {
    name: 'Amazon',
    logo: '/images/sellers/amazon.svg',
    url: 'https://www.amazon.com/dp/B0G2BCQQJY',
  },
  {
    name: 'Bookshop',
    logo: '/images/sellers/bookshop.svg',
    logoHeight: 'h-5',
    url: 'https://bookshop.org/p/books/designing-multi-agent-systems-principles-patterns-and-implementation-for-ai-agents-victor-dibia/bb726b791e9a546e?ean=9798993101200&next=t',
  },
  {
    name: 'Barnes & Noble',
    logo: '/images/sellers/barnesnoble.svg',
    logoHeight: 'h-5',
    url: 'https://www.barnesandnoble.com/w/designing-multi-agent-systems-victor-dibia/1149126926?ean=9798993101200',
  },
]

const HomeView = () => {
  const { t } = useTranslation("home");

  const navSections: NavSection[] = [
    { id: "inside-the-book", label: t("sectionNav.insideTheBook") },
    { id: "testimonials", label: t("sectionNav.testimonials") },
    { id: "about", label: t("sectionNav.about") },
    { id: "faq", label: t("sectionNav.faq") },
  ];

  return (
    <div className="   text-primary  mb-6   border-secondary ">
      <Announcement />

      <SectionNav sections={navSections} firstScrollsToTop />

      <HeroImage />

      {/* Trusted By + Available in Print */}
      <TrustedBy className="mt-10" sellers={printSellers} />

      {/* What's New - Changelog */}
      <section id="whats-new" className="scroll-mt-20">
        <Changelog className="mt-8" />
      </section>

      {/* PicoAgents Interactive Playground */}
      <PicoAgentsPlayground />

      {/* Reading Journey - How to Read This Book */}
      <ReadingJourney compact />

      {/* Testimonials */}
      <section id="testimonials" className="scroll-mt-20">
        {/* Expert Testimonials */}
        <Testimonials
          testimonials={expertTestimonials}
          variant="experts"
        />

        {/* Reader Testimonials */}
        <Testimonials
          testimonials={readerTestimonials}
          variant="readers"
        />
      </section>

      <section id="about" className="scroll-mt-20">
        <AboutAuthors />
      </section>

      <section id="faq" className="scroll-mt-20">
        <Faqs />
      </section>

      <Acknowledgement />
    </div>
  );
};
export default HomeView;
